import { render, staticRenderFns } from "./PromotionDiscountCoupon.vue?vue&type=template&id=9f7a5070&"
import script from "./PromotionDiscountCoupon.vue?vue&type=script&lang=js&"
export * from "./PromotionDiscountCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports